import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3588d2ab&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3588d2ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588d2ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3588d2ab')) {
      api.createRecord('3588d2ab', component.options)
    } else {
      api.reload('3588d2ab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3588d2ab&scoped=true", function () {
      api.rerender('3588d2ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/list/index.vue"
export default component.exports